"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ReactDOM = __importStar(require("react-dom"));
require("./Portal.css");
function Portal(_a) {
    var children = _a.children, show = _a.show;
    var container = React.useMemo(function () { return document.createElement("div"); }, []);
    React.useEffect(function () {
        document.body.appendChild(container);
        return function () {
            document.body.removeChild(container);
        };
    }, [container]);
    var bodyClassName = "nimbus--portal--open";
    React.useEffect(function () {
        if (show) {
            document.body.classList.add(bodyClassName);
        }
        else {
            document.body.classList.remove(bodyClassName);
        }
        return function () {
            document.body.classList.remove(bodyClassName);
        };
    }, [show]);
    var element = (React.createElement("div", { className: "nimbus--portal ".concat(show ? "is-visible" : "") }, children));
    return ReactDOM.createPortal(element, container);
}
exports.default = Portal;
//# sourceMappingURL=Portal.js.map